import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const HandleRedirectError = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.hash.replace('#', '?'));
    const error = urlParams.get('error');

    if (error === 'access_denied') {
      navigate('/', { replace: true });
    }
  }, [navigate]);

  return null;
};

export default HandleRedirectError;
